import React from "react";
import { Box, Text, UnstyledButton } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import styles from "./MobileFabStack.module.css";

export interface MobileFabAction {
  key: string;
  label: string;
  /** Circle fill. */
  color: string;
  icon: React.ReactNode;
  onSelect: () => void;
}

export interface MobileFabStackProps {
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  actions: MobileFabAction[];
}

/**
 * 56px teal FAB that expands upward into labelled create rows over a scrim;
 * the Plus rotates 45° to an X while open.
 */
export const MobileFabStack: React.FC<MobileFabStackProps> = ({
  open,
  onToggle,
  onClose,
  actions,
}) => (
  <>
    {open && (
      <Box
        className={styles.scrim}
        onClick={onClose}
        data-testid="mobile-fab-scrim"
      />
    )}
    {open && (
      <Box className={styles.stack} data-testid="mobile-fab-stack">
        {actions.map((action) => (
          <UnstyledButton
            key={action.key}
            className={styles.row}
            onClick={() => {
              onClose();
              action.onSelect();
            }}
          >
            <Text span className={styles.label}>
              {action.label}
            </Text>
            <Box
              component="span"
              className={styles.circle}
              style={{ background: action.color }}
            >
              {action.icon}
            </Box>
          </UnstyledButton>
        ))}
      </Box>
    )}
    <UnstyledButton
      className={styles.fab}
      onClick={onToggle}
      aria-label="New appointment"
      aria-expanded={open}
    >
      <Box component="span" className={styles.fabIcon} data-open={open}>
        <IconPlus size={24} stroke={1.8} />
      </Box>
    </UnstyledButton>
  </>
);
